"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wktToGeoJson = void 0;
var betterknown_1 = require("betterknown");
/*
    Callback function for the MapPlugin.
    Uses betterknown to parse WktLiterals (including MULTIPOLYGON, LINESTRING, LINESTRING Z)
    to GeoJSON geometries.
*/
var wktToGeoJson = function (literal) {
    // betterknown handles GeoSPARQL-flavored WKT natively,
    // including the <IRI> prefix and all geometry types
    var result = (0, betterknown_1.wktToGeoJSON)(literal);
    if (!result) {
        throw new Error("Failed to parse WKT literal: ".concat(literal));
    }
    return result;
};
exports.wktToGeoJson = wktToGeoJson;
